import React from 'react';
// import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
// import Media from 'react-media';
// import { Formik, Field, Form } from 'formik';
// import { css } from 'react-emotion';
import filter from 'lodash/filter';
import orderBy from 'lodash/orderBy';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router';
import Loading from '../../../components/Loading';

const queryPlans = gql`
  query plans {
    plans {
      id
      name
      interval
      amount
    }
  }
`;

const withData = graphql(queryPlans, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
});

@withData
@withRouter
class AddPlanModal extends React.Component {
  // constructor() {
  //   super();
  //   this.handleClick = this.handleClick.bind(this);
  // }

  getFilterBy = () => {
    const { addedPlans } = this.props;
    if (!addedPlans.length) {
      return { shouldFilter: false };
    }

    const firstPlanInterval = addedPlans[0].interval;
    return {
      shouldFilter: true,
      filterBy: firstPlanInterval,
    }
  }

  handleClick = plan => {
    this.props.addPlan(plan);
  };

  render() {
    const {
      showModal,
      contentLabel,
      handleCloseModal,
      // params: { organizationId },
      data: { plans, loading },
    } = this.props;
    console.log('blah', this.props);
    if (loading) return <Loading />;

    const filterBy = this.getFilterBy(); 
    const filteredList = (filterBy.shouldFilter) ? filter(plans, {'interval': filterBy.filterBy}) : plans;
    const sortedPlans = filteredList && orderBy(filteredList, [(p) => parseInt(p.id, 10)], ['asc']);
    console.log('added', filterBy, this.props.addedPlans);
    return (
      <ReactModal
        isOpen={showModal}
        contentLabel={contentLabel}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            overflowY: 'auto',
          },
          content: {
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: 0,
            border: 'none',
            bottom: 'auto',
            borderRadius: 4,
            maxWidth: '40vw',
          },
        }}
      >
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#eee' }}>
            <h5 className="modal-title">{contentLabel}</h5>
            <button
              onClick={handleCloseModal}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i
                className="fa fa fa-times"
                style={{ fontSize: '1.3em', color: '#808080' }}
              />
            </button>
          </div>
          <div className="modal-body">
            <ul className="list-group">
              {sortedPlans &&
                sortedPlans.map(p => {
                  const addedPlans = this.props.addedPlans.map(p => parseInt(p.plan_id, 10));
                  const hasBeenAdded = addedPlans.indexOf(parseInt(p.id, 10));
                  const addedButton = (
                    <button type="button" className="btn btn-link" disabled>Added</button>
                  );
                  const addButton = (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => {
                        this.handleClick(p);
                      }}
                    >
                      Add
                    </button>
                  );
                  const priceInterval = `$${parseInt(p.amount, 10)/100}/${p.interval}`;
                  return (
                    <li
                      className={`list-group-item d-flex justify-content-between`}
                      key={p.id}
                    >
                      <div>
                        {p.name} <span className="text-muted">- {p.id}</span>
                        <div className="text-muted">{priceInterval}</div>
                      </div>
                      <div className="form-inline">
                        {hasBeenAdded >= 0 ? addedButton : addButton}
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default class AddPlanButton extends React.Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={this.handleClick}
        >
          <i
            className="fa fa-plus"
            aria-hidden="true"
            style={{ marginRight: 5 }}
          />
          Add a Plan
        </button>
        <AddPlanModal
          showModal={this.state.open}
          handleCloseModal={this.handleClose}
          contentLabel={'Add a Plan'}
          addPlan={this.props.addPlan}
          addedPlans={this.props.addedPlans}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/ModalButtons/AddPlan.js